import { AbstractControl, FormGroupDirective, Validators } from '@angular/forms';
import { Directive, ElementRef, Input, Renderer2, afterNextRender, inject } from '@angular/core';

// The asterisk follows the control's own required validator, never hand-typed text.
@Directive({
    standalone: false,
    selector: '[appAddAsterisk]',
})
export class AddAsteriskDirective {
    @Input('appAddAsterisk') controlName!: string;

    private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly renderer = inject(Renderer2);
    private readonly formGroupDir = inject(FormGroupDirective, { optional: true });

    constructor() {
        afterNextRender(() => this.addAsterisk());
    }

    private addAsterisk(): void {
        const control = this.formGroupDir?.form?.get(this.controlName);
        if (!this.hasRequiredValidator(control)) return;

        const asterisk = this.renderer.createElement('span') as HTMLElement;
        this.renderer.appendChild(asterisk, this.renderer.createText(' *'));
        this.renderer.setAttribute(asterisk, 'aria-hidden', 'true');
        this.renderer.setStyle(asterisk, 'color', 'var(--text-error)');
        this.renderer.appendChild(this.el.nativeElement, asterisk);
    }

    private hasRequiredValidator(control: AbstractControl | null | undefined): boolean {
        return !!control?.hasValidator?.(Validators.required);
    }
}
